import { ReactComponent as RepeatSvg } from '../../assets/icons/repeat.svg';

export const RepeatIcon: SvgIcon = (props) => {
    return <RepeatSvg {...props} />;
};
